// import { HashRouter } from "react-router-dom";
import React, { Fragment, useEffect, useLayoutEffect, useState } from 'react';
import TrackingTags from './TrackingTags';
import { Header, AppLoader } from './components';
import { RoutesComponent } from './routes/route';
import { ToastContainer } from 'react-toastify';
// import './assets/styles/style.css';
// import './assets/styles/scss/global.scss';
import 'react-toastify/dist/ReactToastify.css';
import { motion, AnimatePresence } from 'framer-motion'
import { useLocation } from 'react-router-dom';
import { BASE_URL_UI } from './config/config';
// import { PublicService } from './core/services';
import { FbConversionTrack } from './core/services/FbConversionTrackEvents';
import MobileFooter from './components/mobile/mobile-footer';
import { isMobile } from 'react-device-detect';
import { isBrdAdminPath, isBrdFramedPath, isBrdLookPath } from './modules/brand/routes';
import './modules/brand/brdRouteShell.scss';
import { isInfluencerFlowPath } from './modules/influencer/routes';
import './modules/influencer/infRouteShell.scss';

// const publicService: PublicService = new PublicService();
const fbConversionEvents: FbConversionTrack = new FbConversionTrack();

// const trackPageView = async () => {
//     try {
//         const url = window.location.href;
//         const response = await publicService.recordFbConversionPageView({ url: url });
//         // console.log('Response:', response);
//     } catch (error) {
//         console.error('Error sending POST request:', error);
//     }
// };

const App: React.FC = () => {
    // Tracking FB conversion page view event.
    const location = useLocation();

    useEffect(() => {
        fbConversionEvents.trackPageView();
    }, [location]);
    // End of tracking FB conversion page view event.

    // The new brand flow (/brand/home, /brand/campaigns … — isBrdFlowPath) hides the site header on phones.
    // Decided from the URL before the first paint (layout effect), not from the
    // flow's lazily loaded page — that left the old header flashing while its
    // code downloaded. Styles: modules/brand/brdRouteShell.scss.
    const brdFlow = isBrdFramedPath(location.pathname);
    useLayoutEffect(() => {
        document.documentElement.classList.toggle('brd-flow-route', brdFlow);
    }, [brdFlow]);
    // Restyled older pages that keep the site header on phones (Brand Pulse search …).
    const brdLook = isBrdLookPath(location.pathname);
    useLayoutEffect(() => {
        document.documentElement.classList.toggle('brd-look-route', brdLook);
    }, [brdLook]);
    // The admin dashboard: the flow's look over its older pages (pages/brand/admin/admin-dashboard/admin-theme.scss).
    const brdAdmin = isBrdAdminPath(location.pathname);
    useLayoutEffect(() => {
        document.documentElement.classList.toggle('brd-admin-route', brdAdmin);
    }, [brdAdmin]);
    // The influencer side of the new flow (/influencer/home … — isInfluencerFlowPath): its page frame,
    // the same way (modules/influencer/infRouteShell.scss).
    const infFlow = isInfluencerFlowPath(location.pathname);
    useLayoutEffect(() => {
        document.documentElement.classList.toggle('inf-flow-route', infFlow);
    }, [infFlow]);
    const showHeader = location.pathname !== '/subscription/invoice';
    // Public pages that hide the site header (keep in sync with hideHeader in header.tsx).
    const isHeaderlessPage = location.pathname.startsWith('/shop') || location.pathname.startsWith('/bio') || location.pathname.startsWith('/form/') || location.pathname === '/subscription';

    return (
        <>
            {
                String(BASE_URL_UI).includes("clanconnect.ai") &&
                <TrackingTags />
            }
            <AppLoader />
            {
                !window.location.pathname.includes("/v360/clients/registration") && <Header />
            }
            {/* {showHeader && <Header />} */}
            <ToastContainer
                autoClose={2000}
                style={{ width: '250px' }}
                position='top-right'
            />
            {/* /shop and /bio hide the fixed site-header (see hideHeader in
                header.tsx), so drop the 120px top margin that clears it —
                otherwise a blank gap shows above the page. Inline style so it
                wins over the .main-content-sec CSS regardless of specificity. */}
            {/* <div
                className={`main-content-sec${(location.pathname.startsWith('/shop') || location.pathname.startsWith('/bio')) ? ' no-header-spacing' : ''}`}
                style={(location.pathname.startsWith('/shop') || location.pathname.startsWith('/bio')) ? { marginTop: 0, minHeight: '100vh' } : undefined}
            > */}
            <div
                className={`main-content-sec${isHeaderlessPage ? ' no-header-spacing' : ''}`}
                style={isHeaderlessPage ? { marginTop: 0, minHeight: '100vh' } : undefined}
            >
                <RoutesComponent />
            </div>
            {/* {isMobile &&
                <MobileFooter />
            } */}
        </>

    );
};

export default App;
